import React from "react";
import { DepositWithdrawDialog } from "../dialogs/deposit-withdraw/deposit-withdraw-dialog.component";
import { TePageFooter } from "../layout/te-footer.component";
import { TePageHeader } from "../layout/te-header.component";
import { TeMain } from "../layout/te-main-body.component";
import { TeMainNavigation } from "../layout/te-main-navigation.component";
import { TraderPageSidebar } from "../sidebar/trader-page-sidebar.component";
import { ISwapData, SwapControl } from "../swap/swap-control.component";
import { DepositWithdrawDialogTab, DialogState } from "../../global/types";
import { ethers } from "ethers";
import { IContract, ITokenContract } from "../../ABIs/contract_map";
import { AcceptedFCAContext, WalletContext } from "../../global/contexts";
import { useNavigate } from "react-router-dom";

interface ITraderBotPageProps {
  activeRoute: string;
  dialogState: DialogState;
  dialogTab: DepositWithdrawDialogTab;
  getTokenApprovedAmount: (token: ITokenContract, approvedAddress?: string) => Promise<ethers.BigNumber>;
  getTokenBalance: (token: ITokenContract) => Promise<ethers.BigNumber>;
  swap: (data: ISwapData, token: ITokenContract) => void;
  swapTokenHolder: (swapData: ISwapData, fromToken: IContract) => Promise<void>;
}

const defaultProps: ITraderBotPageProps = {
  activeRoute: "",
  dialogState: "CLOSED",
  dialogTab: "NONE",
  getTokenApprovedAmount: (a, b) => new Promise(() => console.warn("getTokenApprovedAmount not bound")),
  getTokenBalance: (a) => new Promise(() => console.warn("getTokenBalance not bound")),
  swap: (a, b) => new Promise(() => console.warn("swap not bound")),
  swapTokenHolder: (a, b) => new Promise(() => console.warn("swapTokenHolder not bound")),
};

// SWAP PAGE
export function SwapPage(props = defaultProps) {
  const { acceptedFcaNotice } = React.useContext(AcceptedFCAContext);
  const { wallet } = React.useContext(WalletContext);

  const navigate = useNavigate();

  React.useEffect(() => {
    if (acceptedFcaNotice === false) {
      navigate("/");
    }
  }, [acceptedFcaNotice, navigate]);

  return (
    <div className={`etx-app-wrapper ${props.dialogState === "OPEN" ? "overlay-show" : null}`}>
      <TePageHeader
        title="Swap"
        description={
          <a href="https://0x.org/" target="_blank" rel="noreferrer">
            <img
              src="https://assets.website-files.com/640bf70a17d12b42d97a052b/641a220f0ec6db351732ce83_brand-powered-by-0x-white.svg"
              alt="Powered by 0x"
              style={{ alignContent: "center", width: "150px", height: "30px", filter: "brightness(50%)" }}
            />
          </a>
        }
        acceptedFcaNotice={true}
      />
      <TeMain
        navigation={<TeMainNavigation activeRoute={props.activeRoute} />}
        main={
          <div className="etx-main">
            <div className="etx-main__body">
              {
                wallet.connectionState === "CONNECTED"
                  ? <SwapControl
                    getTokenApprovedAmount={props.getTokenApprovedAmount}
                    getTokenBalance={props.getTokenBalance}
                    swap={props.swap}
                    swapTokenHolder={props.swapTokenHolder}
                  />
                  : ""
              }
            </div>
          </div>
        }
        sidebar={<TraderPageSidebar />}
      />
      <TePageFooter />
      {
        props.dialogState === "OPEN"
          ? <DepositWithdrawDialog dialogTab={props.dialogTab} />
          : ""
      }
    </div>
  );
}
